// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2PWvv","content":"RecentSearches_content__2xTQ0"};